import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import {
  accountKindLabel,
  DevQuickLoginKind,
  DevQuickLoginStore,
  DevQuickLoginUser,
} from './dev-quick-login.store';

@Component({
  selector: 'app-dev-quick-login',
  templateUrl: './dev-quick-login.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
})
export class DevQuickLogin {
  private readonly store = inject(DevQuickLoginStore);

  readonly busy = input(false);
  readonly embedded = input(false);
  readonly selectUser = output<DevQuickLoginUser>();

  readonly enabled = this.store.enabled;
  readonly users = this.store.users;
  readonly sectionClass = computed(() => {
    if (this.embedded()) {
      return 'mt-4 border-t border-zinc-200 px-0 pb-0 pt-4 dark:border-zinc-700';
    }
    return 'primary-card-container p-4';
  });

  loginAs(user: DevQuickLoginUser): void {
    if (this.busy()) {
      return;
    }
    this.selectUser.emit(user);
  }

  removeUser(user: DevQuickLoginUser): void {
    this.store.remove(user.email);
  }

  kindBadgeClass(kind?: DevQuickLoginKind): string {
    const base = 'm-0 mt-1 w-fit rounded-full px-2 py-0.5 text-xs font-medium';
    switch (kind) {
      case 'shout-plus':
        return `${base} bg-violet-100 text-violet-800 dark:bg-violet-900/60 dark:text-violet-100`;
      case 'agency':
        return `${base} bg-sky-100 text-sky-800 dark:bg-sky-900/60 dark:text-sky-100`;
      case 'brand':
        return `${base} bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-200`;
      default:
        return base;
    }
  }

  kindLabel(kind?: DevQuickLoginKind): string {
    return accountKindLabel(kind);
  }
}
